<template>
    <v-container fluid>
        <template v-if="loading">
            <v-container fluid class="fill-height">
                <v-row justify="center" align="center">
                    <v-col class="text-center" xs="12" md="12">
                        <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-else>
            <v-row>
                <v-col>
                    <v-btn
                        color="indigo"
                        class="white--text"
                        :to="{ name: $t('roles.routes.create') }"
                    >
                        <v-icon left>mdi-shield-account</v-icon>
                        {{ $t('roles.index.buttons.create') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <sarala-table
                        :model="model"
                        ref="table"
                        :headers="headers"
                        :hiddenItems="true"
                    >
                        <template #action="{ item }">
                            <v-tooltip bottom v-if="item.name != 'Admin'">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        tile
                                        v-on="on"
                                        :to="{
                                            name: $t('roles.routes.edit'),
                                            params: { id: item.id },
                                        }"
                                    >
                                        <v-icon color="blue-grey" v-on="on"
                                            >mdi-pencil</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>{{ $t('form.actions.edit') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="item.name != 'Admin'">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        tile
                                        v-on="on"
                                        @click="deleteItem(item)"
                                    >
                                        <v-icon color="red" v-on="on"
                                            >mdi-close</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>{{ $t('form.actions.delete') }}</span>
                            </v-tooltip>
                        </template>
                    </sarala-table>
                </v-col>
            </v-row>

            <confirm
                ref="confirm_remove"
                width="500px"
                :confirmText="$t('dialogs-confirm.buttons.remove')"
                confirmColor="red darken-1"
            ></confirm>
        </template>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Confirm from '@/components/dialogs/Confirm'
import Role from '@/models/Role'

export default {
    components: {
        'sarala-table': SaralaTable,
        confirm: Confirm,
    },

    data: () => {
        return {
            loading: false,
        }
    },

    computed: {
        model() {
            return new Role()
        },

        headers() {
            return [
                {
                    text: this.$t('roles.index.table.name'),
                    value: 'name',
                },
                {
                    text: this.$t('tables.actions'),
                    value: 'action',
                    width: 150,
                    sortable: false,
                    align: 'end',
                },
            ]
        },
    },

    methods: {
        async deleteItem(item) {
            let confirm = await this.$refs.confirm_remove.open(
                this.$t('roles.index.messages.delete'),
                this.$t('roles.index.messages.delete-confirmation', {
                    role: item.name,
                }),
            )

            if (!confirm) return

            let clone = item.clone()

            let res = await clone.delete().catch(() => {})

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('roles.index.bus.delete.error', {
                        role: item.name,
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('roles.index.bus.delete.success', {
                    role: item.name,
                }),
            )
        },
    },
}
</script>
